<template>
    <v-container>
        <div class="d-flex justify-space-between">
            <div style="width: 200px">
                <v-tabs v-model="tab" grow class="tab-btn-style">
                    <v-tab class="c-tab">
                        Enquiry
                    </v-tab>
                    <v-tab class="c-tab">
                        Joined
                    </v-tab>
                </v-tabs>
            </div>
            <bread-crumbs  :items="breadItems"></bread-crumbs>
        </div>

        <div class="nmt-1">
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <enquiry-table></enquiry-table>
                </v-tab-item>
                <v-tab-item>
                    <joined-table></joined-table>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </v-container>
</template>

<script>
    import BreadCrumbs from "../../../components/BreadCrumbs";
    import EnquiryTable from "../../../components/TutorStudents/EnquiryTable.vue";
    import JoinedTable from "../../../components/TutorStudents/JoinedTable";
    import AddToGroupTable from "../../../components/TutorStudents/AddToGroupTable";
    import { getPermitObjects } from "../../../utils/allowedPermissions";

    export default {
        name: "Students",
        components: {AddToGroupTable, JoinedTable, EnquiryTable, BreadCrumbs},
        data() {
            return {
                tab: null,
                permitObj: {},
                breadItems: [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        href: "/",
                        to: {
                            name: "DashBoard"
                        },
                    },
                    {
                        text: 'Students',
                        disabled: true,
                        to: {
                            name: "Students"
                        },
                    },
                ],
            }
        },
        mounted() {
            console.log(this.$store, 'this.$store from Student');
            let links = this.$store?.getters?.permissions;
            let pathName = "APStudents";
            this.permitObj = getPermitObjects(links, pathName)
        }
    }
</script>

<style  lang="scss">
.nmt-1{
    margin-top: -12px;
}
.c-tab{
    background: #F2F0F0;
    transition: background-color .2s;
    &.v-tab--active{
        background: white;
    }
}
</style>